import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';


import { Ruta } from '../Models/Ruta';
@Injectable()
export class RutaService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }


  /**
   * Obtener todas las rutas de la zona espedifica
   * @param compania Codigo de la compañia 
   * @param zona Codigo de la zona
   */
  ObtenerRutas(compania: string, zona: string): Observable<Ruta[]> {

    try {

      let url = this._utiles.getURL("ruta/" + compania + "/" + zona);

      return this._http.get(url).map((response: Response) => {
        return <Ruta[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Guarda el registro de la ruta
   * @param ruta Objeto de tipo "Ruta"
   */
  public GuardarRegistro(ruta: Ruta): Observable<any> {

    try {

      let params = JSON.stringify(ruta);

      let url = this._utiles.getURL("ruta/");

      let headers = new Headers({ 'Content-Type': 'application/json' });

      let data: any;


      return this._http.post(url, ruta, { headers: headers }).map(res => res.json());


    } catch (error) {
      console.log(error);
    }


  }




}
